export enum PackagesEnum {
    BASIC = 'basic',
    PRO = 'pro',
    ENTERPRISE = 'enterprise',
    CLIENT = 'client',
    AGENCY = 'agency',
}
